// Conduit-admin-only int-backed enums. The numeric values ARE lookup-table ids in the conduit database —
// change one side, change both. Single-app, so this stays app-local (typescript/AGENTS.md → Enums);
// anything a second app consumes moves to @trillion/enums.

// 1:1 with Microsoft.Extensions.Logging.LogLevel — the BCL owns these ids (sc-114192 keeps no Trillion copy)
// and the `log_level` lookup (sql/conduit/migrations/V009__conduit_run_log.sql) mirrors them.
export enum LogLevel {
  Trace = 0,
  Debug = 1,
  Information = 2,
  Warning = 3,
  Error = 4,
  Critical = 5,
  None = 6,
}

// 1:1 with dotnet/Data/Trillion.Data/Enums/RunLogKind.cs and the `run_log_kind` lookup.
export enum RunLogKind {
  Line = 1,
  Start = 2,
  Finish = 3,
  Truncated = 4,
}
